import React from 'react';
// Import icons to make the page more visually engaging
import { FiShield, FiLock, FiDatabase, FiUsers, FiShare2, FiAlertTriangle, FiMail, FiLink } from 'react-icons/fi';
import Navbar from './Navbar4';

const IVRDATAPrivacy = () => {
  // A reusable card component for consistent styling on a dark background
  const InfoCard = ({ icon, title, children }) => (
    <div className="bg-[#1a2c6c] border border-blue-900/50 rounded-lg p-6 shadow-xl hover:shadow-2xl hover:border-blue-700 transition-all duration-300">
      <div className="flex items-center mb-4">
        <div className="text-2xl mr-4 text-[#2aabdc]">
          {icon}
        </div>
        <h2 className="text-xl font-semibold text-white">{title}</h2>
      </div>
      <div className="text-gray-300 leading-relaxed">
        {children}
      </div>
    </div>
  );

  return (
    <>
    <Navbar/>
    <div className="min-h-screen" style={{ backgroundColor: '#0c1c5c' }}>
      <div className="max-w-6xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        
        {/* Main Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-extrabold text-white tracking-tight">
            Data Privacy & Compliance
          </h1>
          <p className="mt-4 max-w-3xl mx-auto text-lg text-gray-300 leading-relaxed">
            At IVRVue, your privacy and trust are our top priorities. We are committed to maintaining the confidentiality, integrity, and security of all project-related information entrusted to our platform.
          </p>
        </div>

        {/* Grid layout for the main content cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          
          <InfoCard icon={<FiShield />} title="Our Commitment">
            <ul className="list-disc list-inside space-y-2">
              <li>We never sell your data to third parties.</li>
              <li>We only collect data necessary to deliver our services.</li>
              <li>We store your data securely with enterprise-grade controls.</li>
              <li>We maintain full transparency on how your data is used.</li>
            </ul>
          </InfoCard>

          <InfoCard icon={<FiLock />} title="Data Security Practices">
            <ul className="list-disc list-inside space-y-2">
              <li><strong>Encryption:</strong> Data encrypted in transit (TLS 1.3) and at rest (AES-256).</li>
              <li><strong>Access Control:</strong> Role-based access (RBAC) for authorized access only.</li>
              <li><strong>Regular Audits:</strong> Frequent security reviews and third-party audits.</li>
              <li><strong>Secure Integrations:</strong> Trusted partners like Jira and Google.</li>
            </ul>
          </InfoCard>
          
          <InfoCard icon={<FiDatabase />} title="Your Data, Your Control">
            <ul className="list-disc list-inside space-y-2">
              <li>You own your project data—we simply process it.</li>
              <li>Export, update, or delete your data at any time.</li>
              <li>We comply with major privacy regulations like GDPR & CCPA.</li>
            </ul>
          </InfoCard>

          <InfoCard icon={<FiShare2 />} title="Third-Party Vendors">
            <p>
              We carefully evaluate any third-party services we use (such as cloud storage or payment processors) to ensure they meet the same high standards of security and privacy that we hold ourselves to.
            </p>
          </InfoCard>

          <InfoCard icon={<FiAlertTriangle />} title="Incident Response">
            <p>
              In the rare event of a data breach, IVRVue has a clear incident response plan to contain, investigate, and notify affected customers promptly, following all legal requirements.
            </p>
          </InfoCard>

          {/* Contact Card with the special background color */}
          <div className="rounded-lg p-6 shadow-xl hover:shadow-2xl transition-all duration-300 border border-blue-900/50 hover:border-blue-700" style={{ backgroundColor: '#b0fffb' }}>
             <div className="flex items-center mb-4">
               <div className="text-2xl mr-4 text-[#2aabdc]">
                 <FiUsers />
               </div>
               <h2 className="text-xl font-semibold text-[#0c1c5c]">Contact Us</h2>
             </div>
             <div className="text-[#0c1c5c]/90 space-y-3">
                <p>If you have any questions or concerns about how we handle your data, please reach out:</p>
                <p className="flex items-center">
                  <FiMail className="mr-2 text-[#2aabdc]" />
                  <a href="mailto:compliance@mnrtechnologies.com" className="text-[#0c1c5c] hover:text-[#2aabdc] underline font-medium">
                    compliance@mnrtechnologies.com
                  </a>
                </p>
                <p className="flex items-center">
                  <FiLink className="mr-2 text-[#2aabdc]" />
                  <a href="https://www.mnrpureai.com/ivrvue" target="_blank" rel="noopener noreferrer" className="text-[#0c1c5c] hover:text-[#2aabdc] underline font-medium">
                    www.mnrpureai.com/ivrvue
                  </a>
                </p>
             </div>
          </div>

        </div>
      </div>
    </div>
    </>
  );
};

export default IVRDATAPrivacy;